// Training Plan Data Types and Constants

export const SPORT_TYPES = [
  'cycling',
  'running',
  'moto',
  'mtb',
  'ski',
  'swimming',
  'strength',
  'yoga',
  'other'
];

export const WORKOUT_TYPES = [
  'endurance',
  'tempo',
  'interval',
  'recovery',
  'strength',
  'skill',
  'mental',
  'race',
  'rest',
  'test',
  'custom'
];

export const PERIODIZATION_MODELS = [
  { value: 'linear', label: 'Linear (Gradual Build)' },
  { value: 'reverse', label: 'Reverse (High to Low)' },
  { value: 'block', label: 'Block (Focused Phases)' },
  { value: 'undulating', label: 'Undulating (Weekly Variation)' }
];

export const TRAINING_STYLES = [
  { value: 'polarized', label: 'Polarized (80/20)' },
  { value: 'pyramidal', label: 'Pyramidal' },
  { value: 'threshold', label: 'Threshold Focus' },
  { value: 'sweet-spot', label: 'Sweet Spot' }
];

export const GOAL_TYPES = [
  'endurance',
  'speed',
  'skill',
  'race',
  'weight-loss',
  'general-fitness'
];

export const PRIORITY_LEVELS = [
  { value: 'p1', label: 'P1 - Critical', color: '#ff4444' },
  { value: 'p2', label: 'P2 - Important', color: '#ff8800' },
  { value: 'p3', label: 'P3 - Optional', color: '#ffbb00' }
];

export const WORKOUT_STATUS = [
  'planned',
  'completed',
  'skipped',
  'modified',
  'cancelled'
];

export const PLAN_STATUS = [
  'draft',
  'active',
  'completed',
  'paused'
];

export const ZONE_CALCULATION_METHODS = [
  { value: 'max', label: 'Maximum HR/Power' },
  { value: 'lthr', label: 'Lactate Threshold HR' },
  { value: 'ftp', label: 'Functional Threshold Power' },
  { value: 'lactate', label: 'Lactate Testing' },
  { value: 'custom', label: 'Custom' }
];

// Helper functions
export function getWorkoutTypeLabel(type) {
  const labels = {
    endurance: 'Endurance',
    tempo: 'Tempo',
    interval: 'Interval',
    recovery: 'Recovery',
    strength: 'Strength',
    skill: 'Skills',
    mental: 'Mental Training',
    race: 'Race/Event',
    rest: 'Rest Day',
    test: 'Fitness Test',
    custom: 'Custom'
  };
  return labels[type] || type;
}

export function getSportTypeLabel(sport) {
  const labels = {
    cycling: 'Cycling',
    running: 'Running',
    moto: 'Motorcycle',
    mtb: 'Mountain Bike',
    ski: 'Skiing',
    swimming: 'Swimming',
    strength: 'Strength Training',
    yoga: 'Yoga',
    other: 'Other'
  };
  return labels[sport] || sport;
}

export function getPriorityColor(priority) {
  const priorityObj = PRIORITY_LEVELS.find(p => p.value === priority);
  return priorityObj ? priorityObj.color : '#666';
}
